import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import CRMPropertyDateInput from 'customer-data-properties/date/CRMPropertyDateInput';
import { MomentTypes } from 'customer-data-properties/date/MomentTypes';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import PropertyPropType from '../utils/propTypes/PropertyPropType';
import { getTransferrableProps } from '../utils/getTransferrableProps';
import { memo, useCallback } from 'react';
import refObject from 'UIComponents/utils/propTypes/refObject';
import { DATE } from 'customer-data-objects/property/PropertyTypes';
const propTypes = {
  error: PropTypes.bool,
  inputRef: refObject.isRequired,
  onChange: PropTypes.func,
  property: PropertyPropType.isRequired,
  value: PropTypes.string
};

const PropertyInputDate = (_ref) => {
  let {
    error,
    inputRef,
    onChange,
    property
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["error", "inputRef", "onChange", "property"]);

  const handleChange = useCallback(evt => {
    const {
      target: {
        value
      }
    } = evt;

    if (typeof onChange === 'function') {
      // CRMPropertyDateInput (UIDateInput)'s onChange sends `number | null`; convert to `string | null`
      onChange(value == null ? evt : SyntheticEvent(String(value)));
    }
  }, [onChange]);
  return /*#__PURE__*/_jsx(CRMPropertyDateInput, Object.assign({}, getTransferrableProps(rest), {
    error: error,
    momentType: MomentTypes.USER,
    onChange: handleChange,
    inputRef: inputRef,
    type: property.type === DATE ? 'date' : undefined
  }));
};

PropertyInputDate.propTypes = propTypes;
export default /*#__PURE__*/memo(PropertyInputDate);